'use client';

import Grid from '@/components/_rebrand/Grid';
import { Text } from '@/components/_rebrand/Text';
import { TextCombination } from '@/components/_rebrand/TextCombination';
import YouTubeVideoThumbnail from '@/components/_rebrand/YouTubeVideoThumbnail';
import YouTubeVideoModal from '@/components/modals/YouTubeVideoModal';
import { FC, useState } from 'react';

export type IndustryDemo = {
  title: string;
  videoId: string;
  thumbnailSrc: string;
  thumbnailAlt: string;
};

export type ProductTourIndustryDemosProps = {
  title: string;
  description: string;
  demos: readonly IndustryDemo[];
};

export const ProductTourIndustryDemos: FC<ProductTourIndustryDemosProps> = ({
  title,
  description,
  demos,
}) => {
  const [activeDemo, setActiveDemo] = useState<IndustryDemo | null>(null);

  return (
    <>
      <section>
        <Grid className="gap-y-xl md:gap-y-3xl">
          <div className="col-span-4 md:col-span-8 md:col-start-3">
            <TextCombination
              type="d2p1"
              headingLevel="h2"
              align="center"
              title={title}
              description={description}
            />
          </div>
          {demos.map((demo) => (
            <div key={demo.videoId} className="col-span-4 md:col-span-6 flex flex-col gap-xl">
              <Text type="h2" className="text-primary text-center">
                {demo.title}
              </Text>
              <YouTubeVideoThumbnail
                src={demo.thumbnailSrc}
                alt={demo.thumbnailAlt}
                onClick={() => setActiveDemo(demo)}
              />
            </div>
          ))}
        </Grid>
      </section>

      {activeDemo && (
        <YouTubeVideoModal
          onClose={() => setActiveDemo(null)}
          videoId={activeDemo.videoId}
          coverSrc={activeDemo.thumbnailSrc}
          showPlayButton={false}
          videoName={activeDemo.title}
        />
      )}
    </>
  );
};

export default ProductTourIndustryDemos;
